import { selectAllDicts } from '@/api/modules/dict'

const state = {
    projectDict: {},    // 码表对象
    gclx: [],           // 工程类型(项目类型)
    dxgclx: [],         // 单项工程类型
    dwgclx: [],         // 单位工程类型
    zjjd: [],           // 造价阶段
    jjyj: [],           //计价依据
    gcly: [],           // 工程来源
    zbfs: [],           // 招标方式
    gsbzdeyj: [],       // 概算编制定额依据
    xxjyj: [],          // 信息价依据
    lsqkm: [],          // 六算基本信息区块名称
    bdlx:[],            //表单类型
    ywmb:[],            //业务模板
    qymb:[],            //区域码表
    clfl:[],            // 材料分类
    cldw:[],            //材料单位
    zylx: [],           //资源类型
    xxjgly: [],         //价格信息来源

}

const mutations = {
    SET_DICTS: (state, obj) => {
        state.projectDict = Object.assign({}, obj)
    },
    // 工程类型
    SET_GCLX: (state, arr) => {
        state.gclx = arr
    },
    // 单项工程类型
    SET_DXGCLX: (state, arr) => {
        state.dxgclx = arr
    },
    // 单位工程类型
    SET_DWGCLX: (state, arr) => {
        state.dwgclx = arr
    },
    // 造价阶段
    SET_ZJJD: (state, arr) => {
        state.zjjd = arr
    },
    //计价依据
    SET_JJYJ: (state, arr) =>{
        state.jjyj = arr
    },
    // 工程来源
    SET_GCLY: (state, arr) => {
        state.gcly = arr
    },
    // 招标方式
    SET_ZBFS: (state, arr) => {
        state.zbfs = arr
    },
    // 概算编制定额依据
    SET_GSBZDEYJ: (state, arr) => {
        state.gsbzdeyj = arr
    },
    // 信息价依据
    SET_XXJYJ: (state, arr) => {
        state.xxjyj = arr
    },
    // 六算基本信息区块名称
    SET_LSQKM: (state, arr) => {
        state.lsqkm = arr
    },
    // 表单类型
    SET_BDLX: (state, arr) => {
        state.bdlx = arr
    },
    // 业务模板
    SET_YWMB: (state, arr) => {
        state.ywmb = arr
    },
    // 区域码表
    SET_QYMB: (state, arr) => {
        state.qumb = arr
    },
    //材料分类码表
    SET_CLFL: (state, arr) => {
        state.clfl = arr
    },
    //材料单位码表
    SET_CLDW: (state, arr) => {
        state.cldw = arr
    },
    //资源类型
    SET_ZYLX: (state,arr) =>{
        state.zylx = arr
    },
    //价格信息来源
    SET_XXJGLY: (state,arr) =>{
        state.xxjgly = arr
    },

}

const actions = {
    // 获取码表
    getAllDict({commit}) {
        return new Promise((resolve, reject) => {
            selectAllDicts({}).then(res => {
                // // 保存 token
                commit('SET_DICTS', res.data);
                commit('SET_GCLX', res.data.gclx);
                commit('SET_DXGCLX', res.data.dxgclx);
                commit('SET_DWGCLX', res.data.dwgclx);
                commit('SET_ZJJD', res.data.zjjd);
                commit('SET_JJYJ', res.data.jjyj);
                commit('SET_GCLY', res.data.gcly);
                commit('SET_ZBFS', res.data.zbfs);
                commit('SET_GSBZDEYJ', res.data.gsbzdeyj);
                commit('SET_XXJYJ', res.data.xxjyj);
                commit('SET_LSQKM', res.data.lsqkm);
                commit('SET_BDLX', res.data.bdlx);
                commit('SET_YWMB', res.data.ywmb);
                commit('SET_QYMB', res.data.qymb);
                commit('SET_CLFL', res.data.clfl);
                commit('SET_CLDW', res.data.cldw);
                commit('SET_ZYLX', res.data.zylx);
                commit('SET_XXJGLY',res.data.xxjgly)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}